module.exports = __webpack_public_path__ + "img/person.2e243412.png";